module.exports = __webpack_public_path__ + "img/banner-image.3ddb4801.svg";